const greeting = {
    title: "Daan Sijnja",
    nickname: "Junior Mechatronics Engineer",
    subText: "An eager learner who enjoys hobby electronics projects that offer a challenge and something new to learn."
};

const greeting_points = {
    title: "Mechatronics Engineer",
    list: [
        "- Rapid prototype building",
        "- Building test setups for quality assurance",
        "- PCB and Electronics design",
        "- Writing maintainable firmware design"
    ]
}


export {greeting, greeting_points}